// extracted by mini-css-extract-plugin
export default {"quote":"styles_quote__hhOYQ","author":"styles_author__9+gIb"};